/* Check IE */
var bcMsieVersion = {
  MsieVersion: function() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else {
      return 0;
    }
  },
  init: function() {
    this.MsieVersion();
  }
}

jQuery.fn.extend({
  scrollToMe: function() {
    if (jQuery(this).length) {
      var top = jQuery(this).offset().top - 200;
      jQuery('html,body').animate({
        scrollTop: top
      }, 500);
    }
  },
});

function addCart(){
  jQuery('.cart-sb').addClass('opened');
  $('.mini-cart__slideout').addClass('mini-cart--open');
  setTimeout(function(){
    jQuery('.mini-cart__inner').addClass('is-active');
  }, 400)
  setTimeout(function(){
    jQuery('.mini-cart__overlay').addClass('is-active');
  }, 300)
  jQuery('html').addClass('is-locked');
}

function notifyAddCartFail($i){
  $.jGrowl($i, {
    life: 3000,
    position: 'center'
  });
}

/* Ajax Add To Cart */

function addToCart(e){
  if (typeof e !== 'undefined') e.preventDefault();

  var $this = $(this);
  var form = $this.parents('form');

  // ---- VIN Validation ----
  var vinInput = form.find('#vehicle-registration-vin');
  if (vinInput.length && !vinInput.val().trim()) {
    vinInput.css('border-color', 'red');
    vinInput.focus();
    if ($('#vin-error').length === 0) {
      vinInput.closest('.vin-input-wrapper').after('<p id="vin-error" style="color:red; font-size:13px; margin-top:4px;">Please enter your Vehicle Registration / VIN before adding to cart.</p>');
    }
    return; // Block AJAX
  }
  vinInput.css('border-color', '');
  $('#vin-error').remove();
  // ---- End VIN Validation ----

  $this.addClass('disabled');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: true,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });
}

function addToCartSuccess(jqXHR, textStatus, errorThrown){
  $('.add-to-cart').removeClass('disabled');
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  addCart();
  Shopify.getCart(function(cart) {
    Shopify.updateCartInfo(cart, '#cart-info #cart-content');
  });
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  var $i = '<div class="error">' + response.description + '</div>';
  notifyAddCartFail($i);
  $this.removeClass('disabled');
}

function addcartModalHide(){
  $("#layer-addcart-modal").addClass("zoomOut animated").fadeOut();
  $("#layer-addcart-modal").removeClass("zoomOut animated");
}

jQuery(document).ready(function($) {
  $("body").on('click', '.add-to-cart', addToCart);

  // Clear VIN error and border as user types
  $(document).on('input', '#vehicle-registration-vin', function() {
    $(this).css('border-color', '');
    $('#vin-error').remove();

    // Hide * Required label when typing
    var label = $(this).siblings('.vin-required-label');
    if ($(this).val().trim()) {
      label.css('opacity', '0');
    } else {
      label.css('opacity', '1');
    }
  });
});
